module.exports = __webpack_public_path__ + "img/img9.e27b2e37.png";